<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Cadastro de Usuários</h2>
        <v-spacer></v-spacer>
        <v-btn @click="onNewButtonClick()" small color="primary">Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table1
          :headers="headers"
          :items="usuarios"
          :total="total"
          @refresh="getAll"
          @edit="editItem"
          @delete="deleteItem"
        ></e-data-table1>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import usuarioService from '@/services/usuario'
import EDataTable1 from '@/components/EDataTable1'
import { showError, showConfirm } from '@/utils'

export default {
  name: 'usuario',
  components: {
    EDataTable1
  },
  data () {
    return {
      usuarios: [],
      total: 0,
      headers: [
        { text: 'Nome', value: 'nome', sortable: false },
        { text: 'Ativo', value: 'ativo', sortable: false }
      ],
      valid: true,
      rules: {
        nome: [v => !!v || 'Campo Requerido'],
        ativo: [v => !!v || 'Campo Requerido']
      },
      buttonSaveLoadingVisible: false
    }
  },

  methods: {
    async getAll (page, search) {
      try {
        const result = search === '' ? await usuarioService.getAll(page) : await usuarioService.getByNome(search, page)
        this.total = result._meta.total_items
        this.usuarios = result.data
      } catch (error) {
        this.usuarios = []
        showError(error)
      }
    },
    async deleteItem (item) {
      showConfirm(`Tem certeza que deseja remover usuário ${item.nome} ?`, async result => {
        if (result) {
          try {
            this.loading = true
            await usuarioService.delete(item.id)
            this.getAll(1, '')
          } catch (error) {
            showError(error)
          } finally {
            this.loading = false
          }
        }
      })
    },
    editItem (item) {
      this.$router.push(`/usuarios/editar/${item.id}`)
    },
    onNewButtonClick () {
      this.$router.push(`/usuarios/criar`)
    }
  }
}
</script>
